import {
  FETCH_ORDENES,
  FETCH_ORDEN,
  EDIT_ORDEN,
  FETCH_ORDENES_EN_VERDE,
  FETCH_CLIENTE,
  LOADING_ORDENES,
  SET_FILTRO_ORDENES,
  FETCH_ORDENES_ENCABEZADO,
  RESET_ORDENES
} from './types';
import {
  getOrden,
  fetchOrdenesParams,
  fetchOrdenesEnVerdeParams,
  fetchOrdenesEncabezadoParams
} from "../api/axios";

export const fetchOrdenes = (request) => async dispatch => {
  dispatch({
    type: LOADING_ORDENES,
    payload: true
  });

  const requestParse = { ...request }

  let array = fetchOrdenesParams(requestParse);
  array.then((ordenes) => {
    dispatch({
      type: FETCH_ORDENES,
      payload: ordenes
    });

    dispatch({
      type: LOADING_ORDENES,
      payload: false
    });
  })
}

export const fetchOrdenesEncabezado = (request) => async dispatch => {
  dispatch({
    type: LOADING_ORDENES,
    payload: true
  });

  const requestParse = { ...request }

  let array = fetchOrdenesEncabezadoParams(requestParse);
  array.then((ordenes) => {
    dispatch({
      type: FETCH_ORDENES_ENCABEZADO,
      payload: ordenes
    });

    dispatch({
      type: LOADING_ORDENES,
      payload: false
    });
  }).catch((error) => {
    dispatch({
      type: FETCH_ORDENES_ENCABEZADO,
      payload: []
    });
    dispatch({
      type: LOADING_ORDENES,
      payload: false
    });
  });
}

export const fetchOrdenesEnVerde = (request) => async (dispatch, getState) => {
  dispatch({
    type: LOADING_ORDENES,
    payload: true
  });

  const requestParsed = { ...request };
  const { userType, codProv, userId } = getState().general || {};
  // Proveedor: codProv e idUsuario (la API suele filtrar por uno o ambos; el BFF los fuerza desde el JWT).
  if (userType?.isProveedor) {
    if (codProv !== null && codProv !== undefined && codProv !== '') {
      requestParsed.codProv = codProv;
    }
    if (userId && Number(userId) > 0) {
      requestParsed.idUsuario = Number(userId);
    }
  }

  let array = fetchOrdenesEnVerdeParams(requestParsed);
  array.then((ordenesEnVerde) => {
    dispatch({
      type: FETCH_ORDENES_EN_VERDE,
      payload: ordenesEnVerde
    });

    dispatch({
      type: LOADING_ORDENES,
      payload: false
    });
  }).catch((error) => {
    console.error("Error fetching ordenes:", error);
    dispatch({
      type: LOADING_ORDENES,
      payload: false
    });
  })
}

export const fetchOrden = (id, idUsuario) => async dispatch => {
  dispatch({
    type: LOADING_ORDENES,
    payload: true
  });

  let orden = getOrden(id, idUsuario);

  orden.then((orden) => {
    dispatch({
      type: FETCH_ORDEN,
      payload: orden.elementos[0]
    });

    dispatch({
      type: LOADING_ORDENES,
      payload: false
    });
  })
}

export const fetchDatosComprador = (id, idUsuario) => async dispatch => {
  dispatch({
    type: LOADING_ORDENES,
    payload: true
  });

  let ordenNew = {
    "nombre": "",
    "apellido": "",
    "tipoDocumento": "",
    "documento": 0,
    "domicilio": "",
    "numeroDomicilio": "",
    "piso": "",
    "departamento": "",
    "codigoPostal": "",
    "localidad": "",
    "provincia": "",
    "codigoProvincia": "",
    "email": "",
    "prefijoTelefono": "",
    "telefono": "",
    "prefijoCelular": "",
    "numeroCelular": "",
    "sexo": "",
    "situacionIva": "",
    "cuit": ""
  }

  if (id != undefined) {
    let orden = getOrden(id, idUsuario);
    orden.then((orden) => {
      dispatch({
        type: FETCH_CLIENTE,
        payload: orden.elementos[0].cliente
      });

      dispatch({
        type: LOADING_ORDENES,
        payload: false
      });
    })
  } else {
    dispatch({
      type: FETCH_CLIENTE,
      payload: ordenNew
    });

    dispatch({
      type: LOADING_ORDENES,
      payload: false
    });
  }
}

export const editDatosComprador = (orden) => dispatch => {
  dispatch({
    type: FETCH_CLIENTE,
    payload: orden
  });
}

export const editOrden = (orden) => dispatch => {
  dispatch({
    type: EDIT_ORDEN,
    payload: orden
  });
}

export const setFiltroOrdenes = (filtro) => dispatch => {
  dispatch({
    type: SET_FILTRO_ORDENES,
    payload: filtro
  });
}

export const resetOrdenes = () => dispatch => {
  dispatch({
    type: RESET_ORDENES,
    payload: []
  });
}